// src/components/auth/IdleWarningModal.jsx
import React, { useState, useEffect } from 'react';
import { FiClock, FiAlertTriangle } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';

const IdleWarningModal = () => {
  const { showIdleWarning, dismissIdleWarning, logout } = useAuth();
  const [countdown, setCountdown] = useState(300); // 5 minutes in seconds

  useEffect(() => {
    if (!showIdleWarning) {
      setCountdown(300);
      return;
    }

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          // Auto logout when countdown reaches 0
          logout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [showIdleWarning, logout]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const handleStayLoggedIn = () => {
    dismissIdleWarning();
  };

  const handleLogoutNow = () => {
    logout();
  };

  if (!showIdleWarning) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-4">
            <FiAlertTriangle className="h-8 w-8 text-yellow-600" />
          </div>
          
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Session Timeout Warning
          </h2>
          
          <p className="text-gray-600 mb-6">
            You will be automatically logged out due to inactivity in:
          </p>
          
          <div className="flex items-center justify-center mb-6">
            <FiClock className="h-6 w-6 text-red-500 mr-2" />
            <span className="text-3xl font-bold text-red-500">
              {formatTime(countdown)}
            </span>
          </div>
          
          <p className="text-sm text-gray-500 mb-8">
            This is for your security and data protection compliance.
          </p>
          
          <div className="flex space-x-3">
            <button
              onClick={handleLogoutNow}
              className="flex-1 bg-gray-500 text-white py-3 px-4 rounded-lg hover:bg-gray-600 transition-colors"
            >
              Logout Now
            </button>
            <button
              onClick={handleStayLoggedIn}
              className="flex-1 bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Stay Logged In
            </button>
          </div>
        </div>
        
        <div className="mt-6 pt-4 border-t border-gray-200">
          <div className="flex items-center justify-center text-xs text-gray-500">
            <FiClock className="h-3 w-3 mr-1" />
            <span>Session timeout helps protect your data</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IdleWarningModal;
